module.exports = __webpack_public_path__ + "media/images/e_pidtrymka-ca35c887ce0eaf61c2c222e06c59f3fa.svg";